var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-rules-wrap"},[_c('div',{staticClass:"rules-title"},[_vm._v(_vm._s(_vm.$t('common.groupRule')))]),_c('mpx-image',{class:("group-rule-image "+(_vm.imageStyle)),attrs:{"mode":"heightFix","src":(_vm.ruleImage)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }